// import { useEffect, useState } from "react";
import "./footer.scss"
import Facebook from "../../images/facebook-icon.png";
import Instagram from "../../images/instagram-icon.png";
// import sanityClient from "../../sanityClient";
// import { footerQuery } from "../../queries";

export default function Footer() {
    return (
        <div className="footer">
            <div className="working-hours">
                <h2 className="title">Opening Hours</h2>
                <div className="hours">
                    <div className="item">Monday-Friday: 9am-7pm</div>
                    <div className="item">Saturday: 9am-5pm</div>
                    <div className="item">Sunday: Closed</div>
                </div>
            </div>
            <div className="social-networks">
                <h2 className="title">Follow us</h2>
                <div className="social-icons-wrapper">
                    <a
                        href="https://www.facebook.com/share/1CxtXgytjR/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={Facebook} className="social-icon" alt="Facebook" />
                    </a>

                    <a
                        href="https://www.instagram.com/studio.cleancutz?igsh=MWNxcnJzOGEwYTBucQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={Instagram} className="social-icon" alt="Instagram" />
                    </a>
                </div>
            </div>
            <div className="location">
                <h2 className="title">Location Details</h2>
                <div className="address">
                    <a href="https://maps.app.goo.gl/cWzmMq7U1KD4CPg7A" 
                        className="full-adress-name"
                        target="_blank"
                        rel="noopener noreferrer">
                            Plovdiv Center, boulevard "Knyaginya Maria Luiza" 41, 4000
                    </a>
                    <div className="item">Plovdiv, Bulgaria</div>
                </div>
                {/* <div className="info-text">
                    <div className="text-en">Studio 1 and 2 are located next to each other in the same building</div>
                    <div className="text">Студио 1 и 2 се намират едно до друго в една и съща сграда</div>
                </div> */}
            </div>
        </div>
    )
}